"use client";

import { usePathname } from "next/navigation";
import { ChokhEvent } from "@/components/chokh-event";

/**
 * Sends Chokh's `404` event from the not-found page, once per wrong path
 * (`AN-INT05`).
 *
 * `ChokhEvent` remembers what it sent by name and props, and a client
 * navigation from one wrong URL to another keeps this page mounted with the
 * same props, so the second miss would go unsent. Keying it on the pathname
 * remounts it per path instead. The path itself is not sent as a property: the
 * pageview already carries it.
 *
 * No `window.paStatus` here: on a soft navigation the tracker sent the pageview
 * on the history change, before this component existed, so a status set now
 * would label the next page instead (`AN-PAG01` review).
 */
export function NotFoundEvent() {
  const pathname = usePathname();
  return <ChokhEvent key={pathname} name="404" />;
}
